(ns modal.core
  (:refer-clojure :exclude [resolve])
  (:require
    [cljs.spec.alpha :as s]
    [modal.specs :as sp]
    [very.re-frame.core :as rf]
    [runtime-resolve.core :refer [resolve]]))

(defn modal
  "Provide a data DSL for specifying how to show or hide a modal,
  and which view to render into the modal container.

  See modal.specs/modal-dsl for a complete description.
  "
  [dsl]
  (s/assert ::sp/modal-dsl dsl)
  (if (:open dsl)
    (rf/>evt [:modal/open (:open dsl)])
    (rf/>evt [:modal/close (:close dsl)])))

(rf/reg-event-db
  :modal/open
  (fn [db [sym]]
    (assoc db :modal {:renderer sym
                      :visible? true})))

(rf/reg-event-db
  :modal/close
  (fn [db [sym]]
    (assoc db :modal {:renderer nil
                      :visible? false})))

(rf/reg-sub
  :modal
  (fn [db]
    (:modal db)))

(rf/reg-sub
  :modal/state
  :<- [:modal]
  (fn [modal]
    {:renderer (resolve (:renderer modal))
     :visible? (:visible? modal)}))
